import api from './api';

const attributeService = {
  // Create new attribute type
  createAttribute: async (attributeData) => {
    try {
      const response = await api.post('/attributes', attributeData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all attribute types
  getAllAttributes: async (params = {}) => {
    try {
      const response = await api.get('/attributes', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get attribute by ID
  getAttributeById: async (id) => {
    try {
      const response = await api.get(`/attributes/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update attribute type
  updateAttribute: async (id, attributeData) => {
    try {
      const response = await api.put(`/attributes/${id}`, attributeData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete attribute type
  deleteAttribute: async (id) => {
    try {
      const response = await api.delete(`/attributes/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Add option to attribute
  addAttributeOption: async (attributeId, optionData) => {
    try {
      const response = await api.post(`/attributes/${attributeId}/options`, optionData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all options for an attribute
  getAttributeOptions: async (attributeId) => {
    try {
      const response = await api.get(`/attributes/${attributeId}/options`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update attribute option
  updateAttributeOption: async (optionId, optionData) => {
    try {
      const response = await api.put(`/attributes/options/${optionId}`, optionData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete attribute option
  deleteAttributeOption: async (optionId) => {
    try {
      const response = await api.delete(`/attributes/options/${optionId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get attributes by input type
  getAttributesByType: async (inputType) => {
    try {
      const response = await api.get(`/attributes/type/${inputType}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get attribute usage statistics
  getAttributeStats: async () => {
    try {
      const response = await api.get('/attributes/stats');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get attributes for a specific product
  getAttributesForProduct: async (productId) => {
    try {
      const response = await api.get(`/attributes/product/${productId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Add products to an attribute
  addProductsToAttribute: async (attributeId, productIds) => {
    try {
      const response = await api.post(`/attributes/${attributeId}/products`, { productIds });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Remove products from an attribute
  removeProductsFromAttribute: async (attributeId, productIds) => {
    try {
      const response = await api.delete(`/attributes/${attributeId}/products`, { data: { productIds } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default attributeService;
